import * as React from 'react';
import { AuthState } from 'app/types-shared';
import hoistStatics from 'hoist-non-react-statics';

import get from 'lodash/get';

/**
 * Async load text translations once authenticated and user language becomes avaliable
 * 
 * @param WrappedComponent The react component to inject props onto
 * @param translateMap Dictionary of {prop_name: language_text_id}
 */
export function withTranslation(WrappedComponent: any, path: string) {

  class LazyTranslationProvider extends React.Component<any> {

    private validAuthState(): boolean {
      return this.props.sharedState.authState === AuthState.Authenticated || 
      this.props.sharedState.authState === AuthState.Anonymous;
    }
    // Load language etc when containers mount
    public componentDidMount() {

      const language = get(this.props, 'sharedState.language.value');
      if (this.validAuthState() && !!language) {
        this.props.loadTextCollection([path], language);
      }
    }

    // Load language when user settings is changed
    public componentDidUpdate(prevProps: any) {

      const language = get(this.props, 'sharedState.language.value');

      if (this.validAuthState()
        && !!language
        && language !== get(prevProps, 'sharedState.language.value')) {
        this.props.loadTextCollection([path], language);
      }
    }

    public render() {
      return (<WrappedComponent {...this.props} />);
    }

  }

  return hoistStatics(LazyTranslationProvider, WrappedComponent);
}
